import THREE from "../Three";
import Scene from "./Scene";

export default class Background extends Scene {
  constructor(scene, renderer) {
    super(scene, renderer);
    this.createBackground();
  }

  settings() {
    super.settings();

    this.group = new THREE.Group();
    this.group.name = "effects";

    this.pointLight1 = new THREE.PointLight(0xffffff, 3, 0, 0);
    this.pointLight1.position.set(500, 500, 500);

    this.group.add(this.pointLight1);

    this.scene.add(this.group);
  }

  createBackground() {
    this.video = document.createElement("video");
    this.video.id = "video";
    this.video.type = "video/mp4";
    this.video.crossOrigin = "anonymous";
    this.video.muted = true;
    this.video.playsInline = true;
    this.video.loop = true;
    this.video.src =
      "https://www.datocms-assets.com/40484/1695380972-lotus-bg-opti.mov";

    this.videoTexture = new THREE.VideoTexture(this.video);
    this.videoTexture.minFilter = THREE.LinearFilter;
    this.videoTexture.magFilter = THREE.LinearFilter;

    this.videoMaterial = new THREE.MeshBasicMaterial({
      map: this.videoTexture,
    });
    this.videoGeometry = new THREE.PlaneGeometry(16, 9);
    this.videoMesh = new THREE.Mesh(this.videoGeometry, this.videoMaterial);

    this.videoMesh.position.set(0, 0, 0);
    this.video.play();

    this.group.add(this.videoMesh);
    this.scene.add(this.group);
  }

  switchScenes(currScene, subjects) {
    let groupScene, scene, group;

    for (const subject of subjects) {
      for (const child of subject.scene.children) {
        if (child.type === "Group" && child.name === "effects") {
          groupScene = subject;
          scene = subject.scene;
          group = child;
          break;
        }
      }

      if (groupScene) {
        break;
      }
    }
    if (groupScene !== currScene) {
      if (scene && currScene) {
        scene.remove(group);
        currScene.scene.add(group);
      }
    }
  }

  render() {
    super.render();
  }
}
